export default {
    data() {
        return {
            user: {
                point: 0,
                redeemedCodes: []
            }
        }
    },

    methods: {
        async getUser() {
            try {
                const { data } = await axios.post("/user");

                // if (_.has(data, 'profile_completed') && data.profile_completed == false) {
                //     window.location.href = "/incomplete-profile"

                //     return
                // }

                this.user = data;
            } catch (error) {
                Sentry.captureException(error)
                console.log(error)
            }
        }
    }
}
